module.exports = __webpack_public_path__ + "static/media/img-apply-btn-clicked.45f3e910.png";